import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { ChevronDown } from "lucide-react";

export type SelectOption = {
  label: string;
  value: string;
};

type Props = {
  name: string;
  label?: string;
  value: string | undefined;
  placeholder: string;
  options: SelectOption[];
  disabled: boolean;
  inputClassName?: string;
  error?: string;
  showError?: boolean;
  onChange: (value: string) => void;
  defaultValue?: string;
};

const SelectInput = ({
  name,
  label,
  defaultValue,
  value,
  placeholder,
  options,
  inputClassName,
  disabled,
  error,
  onChange,
  showError = true
}: Props) => {
  return (
    <>
      <div className={`relative w-full flex-1 border ${error ? "border-red-400" : "border-main-blue/50"} rounded-lg text-black ${disabled ? 'bg-neutral-300 border-transparent' : 'text-black bg-transparent'}`}>
        <div className='flex items-center gap-3 h-full'>
          <Select
            onValueChange={value => onChange(value)} 
            value={value}
            defaultValue={defaultValue}
          >
            <SelectTrigger
              name={name}
              className={`text-sm pl-3 pr-3 py-6.5 border-0 w-full ${inputClassName} rounded-lg !h-[38px]`}
              disabled={disabled}
            >
              <SelectValue placeholder={placeholder} />
            </SelectTrigger>
            <SelectContent position='popper' className="border-0!">
              {options.length > 0 &&
                options.map((opt: SelectOption, idx: number) => {
                  return (
                    <SelectItem key={`select-${name}-option-${idx}`} className='text-sm text-white hover:bg-neutral-500 rounded-md transition-all ease-in-out duration-300' value={opt.value}>{opt.label}</SelectItem>
                  )
                })
              }
            </SelectContent>
          </Select>
        </div>
      </div>
      {error && showError && <small className='text-red-400 mt-0 ml-2'>{error}</small>}
    </>
  )
}

export default SelectInput